import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router-dom';
import { createQueryClient, routes, sessionExpiredPath, WebApp } from './app.js';
import { ApiClient } from './api/client.js';
import { loginUrl, pathOf } from './api/login.js';
import './styles.css';

const router = createBrowserRouter(routes);

const api = new ApiClient({
  // Contrato estricto en desarrollo; en producción un campo desconocido se ignora (plan 11 §4.3).
  strictContracts: !import.meta.env.PROD,
  currentPath: () => pathOf(window.location),
  // Navegación de página completa: el BFF redirige a Entra y vuelve a `returnTo` (relativa).
  onLoginRequired: (returnTo) => window.location.assign(loginUrl(returnTo)),
  onSessionExpired: (returnTo) => void router.navigate(sessionExpiredPath(returnTo), { replace: true }),
});

const root = document.getElementById('root');
if (root === null) throw new Error('Falta el elemento #root.');

createRoot(root).render(
  <StrictMode>
    <WebApp router={router} api={api} queryClient={createQueryClient()} />
  </StrictMode>,
);
